import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';

// Lazy-loaded tab containers
const ConfigGeneralPage = React.lazy(() => import('@/modules/config/ConfigGeneralPage'));
const PermisosPage = React.lazy(() => import('@/modules/system/permisos/PermisosPage'));
const PlantillasPage = React.lazy(() => import('@/modules/system/PlantillasPage'));
const MantenimientoPage = React.lazy(() => import('@/modules/maintenance/MantenimientoPage'));
const RoadmapDashboard = React.lazy(() => import('@/modules/system/roadmap/RoadmapDashboard'));
const NotificationTriggersPage = React.lazy(() => import('@/modules/system/notifications/NotificationTriggersPage'));
const ProcedimientosPage = React.lazy(() => import('@/modules/system/procedimientos/ProcedimientosPage'));

// Detail routes (outside tabs)
const UserPermissionsManagement = React.lazy(() => import('@/modules/admin/roles-permissions/UserPermissionsManagement'));

export const configRoutes = [
  // Configuración General (2 niveles + tabs)
  <Route key="/configuracion" path="/configuracion" element={
    <Navigate to="/configuracion/calendarios-anuales" replace />
  } />,
  <Route key="/configuracion/calendarios-anuales" path="/configuracion/calendarios-anuales" element={
    <ProtectedRoute requiredPermission="system.config.view"><ConfigGeneralPage /></ProtectedRoute>
  } />,
  <Route key="/configuracion/integraciones" path="/configuracion/integraciones" element={
    <ProtectedRoute requiredPermission="system.config.view"><ConfigGeneralPage /></ProtectedRoute>
  } />,
  // Redirect legacy
  <Route key="/configuracion/dashboard" path="/configuracion/dashboard" element={<Navigate to="/configuracion/calendarios-anuales" replace />} />,
  // Legacy redirect: permisos movidos a /sistema/permisos
  <Route key="/configuracion/roles/permisos" path="/configuracion/roles/permisos" element={<Navigate to="/sistema/permisos/sistema" replace />} />,
  <Route key="/configuracion/roles/permisos-usuarios" path="/configuracion/roles/permisos-usuarios" element={<Navigate to="/sistema/permisos/detalle-usuario" replace />} />,

  // Permisos (2 niveles + tabs)
  <Route key="/sistema/permisos" path="/sistema/permisos" element={
    <Navigate to="/sistema/permisos/sistema" replace />
  } />,
  <Route key="/sistema/permisos/sistema" path="/sistema/permisos/sistema" element={
    <ProtectedRoute requiredPermission="system.config.view"><PermisosPage /></ProtectedRoute>
  } />,
  <Route key="/sistema/permisos/usuarios" path="/sistema/permisos/usuarios" element={
    <ProtectedRoute requiredPermission="system.config.view"><PermisosPage /></ProtectedRoute>
  } />,
  // Detail route — vive fuera del tab container
  <Route key="/sistema/permisos/detalle-usuario" path="/sistema/permisos/detalle-usuario" element={
    <ProtectedRoute requiredPermission="system.config.view"><UserPermissionsManagement /></ProtectedRoute>
  } />,

  // Plantillas (2 niveles + tabs)
  <Route key="/sistema/plantillas" path="/sistema/plantillas" element={
    <Navigate to="/sistema/plantillas/academicas" replace />
  } />,
  <Route key="/sistema/plantillas/academicas" path="/sistema/plantillas/academicas" element={
    <ProtectedRoute requiredPermission="system.templates.view"><PlantillasPage /></ProtectedRoute>
  } />,
  <Route key="/sistema/plantillas/enrolamiento" path="/sistema/plantillas/enrolamiento" element={
    <ProtectedRoute requiredPermission="system.templates.view"><PlantillasPage /></ProtectedRoute>
  } />,
  <Route key="/sistema/plantillas/email" path="/sistema/plantillas/email" element={
    <ProtectedRoute requiredPermission="system.templates.view"><PlantillasPage /></ProtectedRoute>
  } />,

  // Mantenimiento (2 niveles + tabs) — incluye Roadmap fusionado
  <Route key="/mantenimiento" path="/mantenimiento" element={
    <Navigate to="/mantenimiento/dashboard" replace />
  } />,
  <Route key="/mantenimiento/dashboard" path="/mantenimiento/dashboard" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><MantenimientoPage /></ProtectedRoute>
  } />,
  <Route key="/mantenimiento/performance" path="/mantenimiento/performance" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><MantenimientoPage /></ProtectedRoute>
  } />,
  <Route key="/mantenimiento/testing-playwright" path="/mantenimiento/testing-playwright" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><MantenimientoPage /></ProtectedRoute>
  } />,
  <Route key="/mantenimiento/errores-ai" path="/mantenimiento/errores-ai" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><MantenimientoPage /></ProtectedRoute>
  } />,
  <Route key="/mantenimiento/programado" path="/mantenimiento/programado" element={
    <ProtectedRoute requiredPermission="system.maintenance.manage"><MantenimientoPage /></ProtectedRoute>
  } />,
  // Roadmap — ruta directa bajo Sistema
  <Route key="/sistema/roadmap" path="/sistema/roadmap" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><RoadmapDashboard /></ProtectedRoute>
  } />,
  // Redirect legacy — /mantenimiento/roadmap → /sistema/roadmap
  <Route key="/mantenimiento/roadmap" path="/mantenimiento/roadmap" element={<Navigate to="/sistema/roadmap" replace />} />,

  // Triggers de Notificación (admin)
  <Route key="/sistema/triggers-notificacion" path="/sistema/triggers-notificacion" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><NotificationTriggersPage /></ProtectedRoute>
  } />,

  // Procedimientos organizacionales
  <Route key="/sistema/procedimientos" path="/sistema/procedimientos" element={
    <ProtectedRoute requiredPermission="system.maintenance.view"><ProcedimientosPage /></ProtectedRoute>
  } />,

  // Redirect legacy
  <Route key="/sistema/mantenimiento-programado" path="/sistema/mantenimiento-programado" element={
    <Navigate to="/mantenimiento/programado" replace />
  } />,
];
